export default __webpack_public_path__ + "static/media/watch_icon.87bba190.svg";